"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItems = void 0;
require("core-js/modules/es.parse-int.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _MenuPropTypes = require("./MenuPropTypes");
var _menuUtilityFunctions = require("./menuUtilityFunctions");
var _SubMenuButton = require("./SubMenuButton");
var _SubMenuLink = require("./SubMenuLink");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SubMenuItems = _ref => {
  let {
    menuId,
    subMenuItems,
    isSubMenuOpen,
    isHoverTrigger,
    subMenuId,
    level,
    path = [],
    onActiveMenuFound = () => {},
    onMenuButtonClick = () => {}
  } = _ref;
  if (!subMenuItems || !subMenuItems.length) {
    return '';
  }
  const nextLevel = parseInt(level, 10) + 1;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "subMenuItems subMenuItems_level".concat(level, " ").concat(isHoverTrigger ? 'hoverTrigger' : ''),
    id: subMenuId
  }, subMenuItems.map((subMenuItem, index) => {
    const {
      menuItems: subMenu,
      url,
      icons,
      hideItem,
      isActive,
      isOpen
    } = subMenuItem;
    const hasSubmenu = subMenu && subMenu.length > 0;
    const subMenuId = "".concat(menuId, "_subMenu_").concat(nextLevel, "_").concat(index);
    const subMenuCssClass = (0, _menuUtilityFunctions.GetSubMenuCssClass)({
      level,
      subMenuItem,
      subMenuIsOpen: isOpen
    });
    const treePosition = [...path, index];
    if (hideItem) {
      return null;
    }
    if (isActive) {
      onActiveMenuFound({
        treePosition
      });
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      key: subMenuId,
      className: subMenuCssClass
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "mainMenuItem",
      onMouseEnter: isHoverTrigger ? e => onMenuButtonClick(e, subMenuItem, treePosition) : undefined
    }, /*#__PURE__*/_react.default.createElement(_SubMenuLink.SubMenuLink, {
      subMenuItem: subMenuItem
    }), /*#__PURE__*/_react.default.createElement(_SubMenuButton.SubMenuButton, {
      subMenuItem: subMenuItem,
      subMenuId: subMenuId,
      isSubMenuOpen: isSubMenuOpen,
      hasSubmenu: hasSubmenu,
      treePosition: treePosition,
      onMenuButtonClick: onMenuButtonClick,
      isHoverTrigger: isHoverTrigger
    })), /*#__PURE__*/_react.default.createElement(SubMenuItems, {
      subMenuId: subMenuId,
      subMenuItems: subMenu,
      level: nextLevel,
      path: treePosition,
      onActiveMenuFound: onActiveMenuFound,
      onMenuButtonClick: onMenuButtonClick
    }));
  }));
};
exports.SubMenuItems = SubMenuItems;
SubMenuItems.propTypes = {
  menuId: _propTypes.default.string,
  subMenuItems: _propTypes.default.arrayOf(_propTypes.default.shape(_objectSpread({}, _MenuPropTypes.MenuButtonPropTypes))),
  isSubMenuOpen: _propTypes.default.bool,
  isHoverTrigger: _propTypes.default.bool,
  subMenuId: _propTypes.default.string,
  level: _propTypes.default.number,
  path: _propTypes.default.arrayOf(_propTypes.default.number),
  onActiveMenuFound: _propTypes.default.func,
  onMenuButtonClick: _propTypes.default.func
};